import React, { useEffect, useState } from 'react';
import Icons from '../../Assets';
import styles from './styles.module.scss';

const ScrollButton: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 500) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    if (!isVisible) return <></>;

    return (
        <div className={styles.scrollIcon} onClick={scrollToTop}>
            <Icons.ScrollToTopIcon />
        </div>
    );
};

export default ScrollButton;
